var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.6,4.5H3.4c-1,0-1.9,0.8-1.9,1.9v11.2c0,1,0.8,1.9,1.9,1.9h17.2c1,0,1.9-0.8,1.9-1.9V6.4C22.5,5.3,21.7,4.5,20.6,4.5z  M20.4,5.5L12,11.4L3.5,5.5H20.4z M21.5,17.6c0,0.5-0.4,0.9-0.9,0.9H3.4c-0.5,0-0.9-0.4-0.9-0.9V6.4c0-0.1,0-0.2,0.1-0.3l9.4,6.5 L21.4,6c0,0.1,0.1,0.2,0.1,0.4V17.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.dc64b143dd336439c1368ca34cdc54a3.svg";
export { ForwardRef as ReactComponent };